export default {
  liability: {
    header: 'Liability Coverage',
    body: `<div class="title-sm">Ensure that You’re Insured</div>
<p>If an accident happens, having the right amount of insurance can benefit you personally, financially, and legally.
With Liability Coverage, you can be insured if you’re held responsible for a car accident by having any medical payments
for injuries sustained to drivers, passengers, and pedestrians, as well as bills for property damage covered.
If you become legally liable as a result of a collision, liability also helps to pay for legal defense costs if you get sued.</p>

<div class="title-sm">Components of Liability</div>
<p>There are two main components to Auto Liability: Bodily Injury and Property Damage Liability.</p>
<ul>
<li><b>Bodily Injury Liability </b>helps pay for the costs associated with another person’s injuries, including medical expenses, loss of income and pain and suffering.</li>
<li><b>Property Damage Liability </b>takes care of any expenses that arise from damage caused by you to another driver’s vehicle or property.</li>
</ul>
<p>If you’re involved in a serious auto accident, Liability Coverage can benefit you by providing critical protection against the loss of your home, savings, and income.
Not only is having liability a good idea, but most states require that drivers have it in order to be legal on the road.
It’s important to have enough insurance to keep all of your assets protected and not all auto policies are the same.
Contact a representative with SIG & Associates today for more information about what Liability Coverage can do for you.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  comp: {
    header: 'Comprehensive Coverage',
    body: `<div class="title-sm">Security On and Off the Road</div>
<p>Your Auto Insurance policy already gives you peace of mind behind the wheel. But more than just accidents
happen, and with the right policy from SIG & Associates, you can make sure that the security of your automobile
doesn’t stop the moment you pull into the driveway. Comprehensive Coverage insures your vehicle and equipment
against damage and expenses that result from something other than a collision.</p>
<p>At SIG & Associates, we know that life is full of surprises, and with Comprehensive Coverage you can be prepared for all of them.
Our team of asset protection specialists can prepare a plan that works for you with a variety of impressive features to
insure your car against damages or loss resulting from:</p>
<ul>
<li>Theft or Larceny</li>
<li>Vandalism and Glass Breakage</li>
<li>Fire Damage</li>
<li>Hail, Water, or Flood Damage</li>
<li>Hitting a Deer or Other Animal</li>
<li>Damage from Falling or Flying Objects</li>
</ul>

<div class="title-sm">Other Non-Collision Related Services</div>
<p>In addition to Comprehensive, SIG & Associates also can offer other non-collision oriented services for you and
your car, like Roadside Assistance and Diminishing Deductible.</p>

<ul>
<li><b>Roadside Assistance </b>provides you with advantages like lockout assistance, jump starts, and towing up to 15 miles – all in one convenient package.</li>
<li><b>Diminishing Deductible </b>commends you for being an accident and violation-free driver with an annual credit reward towards your collision deductible.</li>
</ul>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  collision: {
    header: 'Collision Coverage',
    body: `<div class="title-sm">Bumper-to-Bumper Protection for Your Auto</div>
<p>For most drivers, a car is more than just a means of transportation - it’s an investment. And if you’re involved in an accident,
you’ll want to ensure that your investment is protected. With Collision Coverage from SIG & Associates,
you can have damage to your car insured under your policy – whether the damage is a result of an accident with another vehicle or object.</p>

<div class="title-sm">How Much Collision Coverage is Needed?</div>
<p>Different drivers require different coverage options for their Auto Insurance policies.
Determining the right amount of Collision Coverage depends on factors like the age and year of your car, as well as your financial situation.
An insurance specialist from SIG & Associates can help you find an insurance option that best fits your budget.</p>
<p>In addition to protecting you and your car from collisions, we offer benefits that range from rewards and incentives to extended coverage.
Our enhancements include: Diminishing Deductible, GAP Coverage, and Accident Forgiveness for better assurance.</p>

<ul>
<li><b>Diminishing Deductible </b>rewards you with credit towards your collision deductible simply for being an accident and violation-free driver.</li>
<li><b>GAP Coverage </b>picks up the difference when a settlement from an accident is less than the actual amount you owe on your vehicle loan.</li>
<li><b>Accident Forgiveness </b>ensures that your rates won’t increase because of a single accident.</li>
</ul>

<p>Contact SIG & Associates today to see if you qualify for, or want to learn more about Auto Insurance enhancements that can help save you money.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  under: {
    header: 'Uninsured & Under-insured Motorist Coverage',
    body: `
<div class="title-sm">Not Every Driver is a Responsible Driver</div>
<p>As a safe driver, obeying street signs, speed limits, and always using your turn signals is simply part of the routine.
And if you’re ever involved in an accident, your insurance policy typically keeps you protected.</p>
<p>Unfortunately, there are those on the road who don’t share the same safety precautions as you, and if you’re involved in
an accident with a motorist without the right coverage, you may have to take care of any medical payments,
damages, or any other expenses with money from your own pocket.</p>

<div class="title-sm">It’s Important to be Prepared for Everything</div>
<p>Uninsured/Under-insured Motorist Coverage gives you the assurance you need knowing that your medical expenses will be covered.
In cases where the driver at fault does not have adequate liability to pay for your injuries and damages,
you’ll be compensated for the amount in which you are legally entitled to – in regards to you, your passengers,
and your vehicle. Uninsured/Under-insured Motorist Protection may also take care of property damage in some states.</p>
<p>Since Uninsured/Under-insured Motorist Coverage is a separate purchase from your typical Auto Insurance policy,
it’s important to contact SIG & Associates to find out how you can be prepared for any situation on the road.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  diminish: {
    header: 'Diminishing Deductible',
    body: `
<div class="title-sm">Good Drivers Deserve Great Rewards</div>
<p>As a driver, safety should be one of your top concerns – safety for your passengers and for other drivers on the road.
When you find the right coverage with SIG & Associates, you’ll learn that being a responsible driver has its benefits.
With a Diminishing Deductible, you can actually get rewarded for being an accident and violation-free driver.</p>
<p>When you sign up for Diminishing Deductible, you may be eligible to receive an immediate credit on your deductible.
From there, safe driving over time can yield additional deductible benefits up to your selected carrier's maximum limit.</p>
<p>For options and details, talk to a representative with SIG & Associates.
It’s just one more way that we can provide quality coverage options for safe drivers.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  forgive: {
    header: 'Accident Forgiveness',
    body: `
<div class="title-sm">Don’t Let One Accident Hurt Your Record</div>
<p>We understand that accidents happen. On the road, there are many situations that are outside of your control and
sometimes cannot be avoided. At SIG & Associates, we don’t want an accident to hurt your driving record,
or even cause your rates to go up. With the right coverage, you can be forgiven
for your first chargeable accident through Accident Forgiveness.</p>
<p>Under Accident Forgiveness, if you’re involved in an accident, your rates won’t increase – even if the accident is your fault.
This applies only one time per policy, and once it’s been used, you’ll be eligible to receive it again three years later.</p>
<p>Contact SIG & Associates today to find out how you can receive the benefits of Accident Forgiveness for your Auto Insurance policy.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  minor: {
    header: 'Minor Violation Forgiveness',
    body: `
<div class="title-sm">Everyone Deserves Another Chance</div>
<p>We know that if you’re a safe driver, you probably take every precaution possible when behind the wheel.
But if you receive a citation without the right coverage, that one minor violation could affect your good driving record.</p>
<p>At SIG & Associates, we can help you receive a proper coverage option, like Minor Violation Forgiveness, that allows you to avoid accidental points on your license.</p>
<p>With Minor Violation Forgiveness, if you receive a minor traffic citation, you’ll be prepared with the assurance that your rates won’t increase.
Like Accident Forgiveness, this applies only once per policy, and the coverage renews after three years of the most recent minor violation.</p>
<p>To find out more about how you can protect your reputation as a safe driver, contact SIG & Associates today.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  roadside: {
    header: 'Roadside Assistance',
    body: `
<div class="title-sm">Help On the Go</div>
<p>On the road, anything can happen. From flat tires to breakdowns, it’s best to be prepared for it all.
At SIG & Associates, we’re proud to offer the following packages of Roadside Assistance* coverage through Allied Insurance’s trusted “Sign and Drive” service:</p>

<li><b>Diminishing Deductible </b>rewards you with credit towards your collision deductible simply for being an accident and violation-free driver.</li>
<li><b>GAP Coverage </b>picks up the difference when a settlement from an accident is less than the actual amount you owe on your vehicle loan.</li>

<p>With Roadside Assistance, you’ll never be alone behind the wheel. Contact SIG & Associates today to find out how you can get signed up.</p>
<p><small><i>Services apply while driving any vehicle with any occupant from an Allied household (insureds and in-home relatives).</i></small></p>
<p><small><i>*Roadside Assistance coverages and availability vary from state to state. Please contact a representative at SIG & Associates for full details.</i></small></p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  special: {
    header: 'Specialty Auto Insurance',
    body: `
<div class="title-sm">It’s More Than Just a Hobby</div>
<p>Whether it’s an antique, a collectible, or your own custom-built roadster, your Specialty Auto is a labor of love.
If you’re like most enthusiasts, you’ve poured many hours of time and effort into making your auto something unique and special.
At SIG & Associates, we realize that when you’re cruising down the strip, speeding across the track, or making heads turn at a show,
the last thing you’ll want to worry about is whether you have the right insurance.</p>
<p>We believe that your specialty car is not only a major investment, but also an extension of you.
And a vehicle as unique as its driver requires more than a standard insurance policy.
That’s why we’re proud to offer a variety of specialized coverage options for the following vehicles:</p>

<li>Collectibles</li>
<li>Antique and Classic Cars</li>
<li>Hot Rods</li>
<li>Custom-Built Cars</li>
<li>Show Cars</li>
<li>Race Cars</li>

<p>With options and choices ranging from agreed value coverage to spare parts coverage,
SIG & Associates can provide you with the tools you need to insure your timeless automobile.
We even offer multi-vehicle discounts for the avid collector.</p>
<p>Whatever your situation, you can rest assured knowing that your Specialty Auto is protected with SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  '24-hour': {
    header: '24-Hour Customer Service',
    body: `
<div class="title-sm">Round-the-Clock Service for Your Convenience</div>
<p>At SIG & Associates, we strive for quality service with your convenience in mind. By working with a number of carriers
that offer 24/7 support, your insurance policy can serve you when you need it most.
Since accidents and non-collision oriented situations can fall outside of normal business hours, we can provide you with
the resources you need to reach the proper service center during extended hours in case you need assistance.</p>
<p>For claims, accidents, billing information, and more, you can contact our agency or visit our providers page to find what you need.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  towing: {
    header: 'Towing',
    body: `
<div class="title-sm">Help When You Need It Most</div>
<p>Your car gives you the freedom to take on the open road. Whether you’re enjoying the scenic countryside or driving to
your favorite vacation spot, your adventures can be more enjoyable knowing that help is right around the corner with the convenience of Towing services.</p>
<p>In the event of an unexpected breakdown, the last place you’ll want to be is stranded on the side of the road,
or stuck with costly towing fees. By adding optional Towing coverage from SIG & Associates to your Auto Insurance policy,
you’ll get the peace of mind knowing that no matter where your journeys take you, you’ll never be alone.</p>
<p>In addition to our Towing coverage, SIG & Associates also offers Roadside Assistance packages that include valuable
extras like fuel delivery, turn-by-turn directions, jump starts, flat tire repair, and more.
Contact a representative with SIG & Associates today for more information.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  rental: {
    header: 'Rental Reimbursement',
    body: `
<div class="title-sm">Get Back On the Road Faster</div>
<p>We understand that your days are busy, and between work and your family, not having a car is typically out of the equation.
If your vehicle is left out of commission after an accident or theft, SIG & Associates offers Rental Reimbursement services so that you won’t miss a beat.</p>
<p>Rental Reimbursement is an optional coverage option that provides for the expense of renting a substitute vehicle while yours is being repaired or replaced.
Since benefits and details vary by insurance policy, it’s important to speak with an insurance specialist from
SIG & Associates to make sure you know what’s covered and to see if you qualify for this additional service.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  pip: {
    header: 'Personal Injury Protection (PIP)',
    body: `
<div class="title-sm">Coverage that Helps You Get Well</div>
<p>At SIG & Associates, we know that the safety and well being of you and your family is important, both on and off the road.
Since auto accidents can involve more than just damage to your car, we’re here to help prepare you for insuring any injuries
to you or a family member as a result of an auto accident.</p>
<p>With Personal Injury Coverage from SIG & Associates, you’ll have a policy that helps pay for the treatment of you and
your family members should someone get injured as a passenger or pedestrian. PIP extends to cover expenses beyond medical bills,
such as loss of wages or services, and in some cases, funeral costs. Personal Injury also can extend to take care of your passengers’ bills.</p>
<p>Don’t let the cost of medical expenses be a burden. Get your family treated and on the road to recovery with Personal Injury Coverage from SIG & Associates.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  },
  medical: {
    header: 'Medical Payments Coverage',
    body: `
<div class="title-sm">You Can’t Put a Price on Safety</div>
<p>When it comes to the safety and security of you and your family, nothing should be left to chance.
If you or your loved ones get involved in a car accident, your number one priority should be to make sure everyone
receives the care and treatment they need – at a cost that keeps your finances and savings intact.</p>
<p>Being insured with an auto policy that includes covering Medical Payments ensures that most medical expenses
will be taken care of if you or a family member is injured in an auto accident as either a passenger in the car,
or as a pedestrian struck by an auto. This coverage applies the same regardless of who is at fault and extends to
the policyholder’s family members, as well as any passengers in the vehicle.</p>
<p>The rising cost of healthcare has made paying out of pocket for major medical expenses extremely difficult.
If you worry about not being able to take care of your family in the event of an accident,
keep in mind that with the right Auto Insurance policy, you won’t have to anymore.</p>
<p>Contact SIG & Associates today to learn about how the right coverage can keep those you care about most protected.</p>`,
    footer: 'Wichita Falls TX & Haslet TX'
  }
}



// WEBPACK FOOTER //
// ./src/helpers/autoHelper.js